import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';
import ExpansionPanel from '../../../SolvPatternLibrary/AccordionExpansionPanel';
import { colors } from '~/constants/colors';
import { fontFamily } from '~/constants/text';
import { BASE_URL, HELP_BASE_URL } from '../../../../config';
import {
  FIND_PATH,
  URGENT_CARE_NEAR_ME_PATH,
  PEDIATRIC_NEAR_ME_PATH,
  BLOG_PATH,
  FAQ_PATH,
  FOR_PROVIDERS_BLOG_PATH,
  CAREERS_PATH,
  FOR_PROVIDERS_PATH,
  ABOUT_US_PATH,
  WALK_IN_CLINIC_NEAR_ME_PATH,
  HEALTH_AZ_PATH,
  VIDEO_TELEMEDICINE_PATH,
  VA_URGENT_CARE_NEAR_ME_PATH,
  PRESS_PATH,
  COVID_TESTING_PATH,
  COVID_VACCINE_PATH,
  ACCREDITED_URGENT_CARE_PATH,
  COVID_PATH,
  CONTACTLESS_DEMO_PATH,
  INTEGRATIONS_PATH,
  URGENT_CARE_MARKETING_PATH,
  FOR_PROVIDERS_COVID_TESTING_VACCINE_PATH,
  FOR_PROVIDERS_PRICING_PATH,
  REQUEST_DEMO_PATH,
  CASE_STUDIES_PATH,
  WEBINARS_PATH,
  EBOOKS_PATH,
  PATIENT_BOOST_PATH,
} from '../../../../constants';
import AppStoreBadge from '~/components/DownloadDriver/AppStoreBadge';
import { campaignNames } from '~/core/analytics/events';

const expansionPanelTheme = {
  backgroundColor: colors.myRightFoot,
  width: '100%',
  a: {
    textDecoration: 'none',
  },
  panelDetails: {
    backgroundColor: colors.squid,
    p: {
      color: colors.white,
      margin: '0px',
    },
  },
  panelSummary: {
    backgroundColor: colors.squid,
    p: {
      color: colors.white,
    },
  },
};

const SectionTitle = styled.h5`
  color: ${colors.white}!important;
  font-family: ${fontFamily.bold}!important;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  margin-top: 0;
  margin-bottom: 0;

  a {
    color: ${colors.white};
  }
`;

const Link = styled.div`
  color: ${colors.borderLine};
  font-family: ${fontFamily.book};
  font-weight: bold;
  -webkit-font-smoothing: antialiased;
  line-height: 24px;
  font-size: 12px;
  a {
    color: ${colors.borderLine};
    font-weight: bold;
  }
  a:visited {
    color: ${colors.borderLine};
  }
`;

const StyledAnchor = styled.a`
  color: ${colors.borderLine};
  wrap-option: nowrap;

  :visited {
    color: ${colors.borderLine};
  }
`;

const ForProvidersSection = styled.div`
  white-space: nowrap;
`;

const Mobile = () => {
  return (
    <ExpansionPanel
      panels={[
        {
          id: 'findCare',

          expandIcon: <ExpandMoreIcon htmlColor="white" />,
          title: (
            <SectionTitle>
              <StyledAnchor href={`${BASE_URL}${FIND_PATH}`}>Find Care</StyledAnchor>
            </SectionTitle>
          ),

          content: (
            <div>
              <Link>
                <StyledAnchor href={`${BASE_URL}${COVID_TESTING_PATH}`}>
                  COVID Testing Near Me
                </StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href={`${BASE_URL}${COVID_VACCINE_PATH}`}>
                  COVID Vaccine Near Me
                </StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href={`${BASE_URL}${URGENT_CARE_NEAR_ME_PATH}`}>
                  Urgent Care Near Me
                </StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href={`${BASE_URL}${PEDIATRIC_NEAR_ME_PATH}`}>
                  Pediatric Urgent Care Near Me
                </StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href={`${BASE_URL}${WALK_IN_CLINIC_NEAR_ME_PATH}`}>
                  Walk-in Clinic Near Me
                </StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href={`${BASE_URL}${VA_URGENT_CARE_NEAR_ME_PATH}`}>
                  VA Urgent Care Near Me
                </StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href={`${BASE_URL}${ACCREDITED_URGENT_CARE_PATH}`}>
                  Certified & Accredited Urgent Care
                </StyledAnchor>
              </Link>
            </div>
          ),
        },
        {
          id: 'resources',

          expandIcon: <ExpandMoreIcon htmlColor="white" />,
          title: (
            <SectionTitle>
              <StyledAnchor href={`${BASE_URL}${BLOG_PATH}`}>Resources</StyledAnchor>
            </SectionTitle>
          ),

          content: (
            <div>
              <Link>
                <StyledAnchor href={`${BASE_URL}${COVID_PATH}`}>COVID Care Guide</StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href={`${BASE_URL}${BLOG_PATH}`}>In Good Health Blog</StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href={`${BASE_URL}${FAQ_PATH}`}>Health FAQs</StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href={`${BASE_URL}${HEALTH_AZ_PATH}`}>Health A-Z</StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href={HELP_BASE_URL}>Help</StyledAnchor>
              </Link>
            </div>
          ),
        },
        {
          id: 'aboutUs',

          expandIcon: <ExpandMoreIcon htmlColor="white" />,
          title: (
            <SectionTitle>
              <StyledAnchor href={`${BASE_URL}${ABOUT_US_PATH}`}>About Us</StyledAnchor>
            </SectionTitle>
          ),

          content: (
            <div>
              <Link>
                <StyledAnchor href={`${BASE_URL}${CAREERS_PATH}`}>Careers</StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href={`${BASE_URL}${PRESS_PATH}`}>Press</StyledAnchor>
              </Link>

              <Link>
                <StyledAnchor href="mailto:info@solvhealth.com">Contact</StyledAnchor>
              </Link>
            </div>
          ),
        },
        {
          id: 'getOurApp',

          expandIcon: <ExpandMoreIcon htmlColor="white" />,
          title: <SectionTitle>Get Our App</SectionTitle>,

          content: (
            <div>
              <AppStoreBadge campaignName={campaignNames.DESKTOP_FOOTER} newWindow store="ios" />
              <AppStoreBadge
                campaignName={campaignNames.DESKTOP_FOOTER}
                newWindow
                store="android"
              />
            </div>
          ),
        },
        {
          id: 'forProviders',

          expandIcon: <ExpandMoreIcon htmlColor="white" />,
          title: (
            <SectionTitle>
              <StyledAnchor href={`${BASE_URL}${FOR_PROVIDERS_PATH}`}>For Providers</StyledAnchor>
            </SectionTitle>
          ),
          content: (
            <ForProvidersSection>
              <Grid align-items="flex-start" container spacing={6}>
                <Grid item xs={6}>
                  <Link>
                    <StyledAnchor href={`${BASE_URL}${FOR_PROVIDERS_PATH}`}>
                      Patient Experience
                    </StyledAnchor>
                  </Link>

                  <Link>
                    <StyledAnchor href={`${BASE_URL}${CONTACTLESS_DEMO_PATH}`}>
                      Contactless Checkin
                    </StyledAnchor>
                  </Link>

                  <Link>
                    <StyledAnchor href={`${BASE_URL}${PATIENT_BOOST_PATH}`}>
                      Patient Acquisition
                    </StyledAnchor>
                  </Link>

                  <Link>
                    <StyledAnchor href={`${BASE_URL}${VIDEO_TELEMEDICINE_PATH}`}>
                      Telemedicine
                    </StyledAnchor>
                  </Link>

                  <Link>
                    <StyledAnchor href={`${BASE_URL}${INTEGRATIONS_PATH}`}>
                      EHR Integration
                    </StyledAnchor>
                  </Link>

                  <Link>
                    <StyledAnchor href={`${BASE_URL}${URGENT_CARE_MARKETING_PATH}`}>
                      Urgent Care Marketing
                    </StyledAnchor>
                  </Link>

                  <Link>
                    <StyledAnchor href={`${BASE_URL}${FOR_PROVIDERS_COVID_TESTING_VACCINE_PATH}`}>
                      COVID Solutions
                    </StyledAnchor>
                  </Link>
                </Grid>
                <Grid item xs={3}>
                  <Link>
                    <StyledAnchor href={`${BASE_URL}${FOR_PROVIDERS_PRICING_PATH}`}>
                      Pricing
                    </StyledAnchor>
                  </Link>

                  <Link>
                    <StyledAnchor href={`${BASE_URL}${REQUEST_DEMO_PATH}`}>
                      Request a Demo{' '}
                    </StyledAnchor>
                  </Link>

                  <Link>
                    <StyledAnchor href={`${BASE_URL}${FOR_PROVIDERS_BLOG_PATH}`}>
                      Provider Blog
                    </StyledAnchor>
                  </Link>

                  <Link>
                    <StyledAnchor href={`${BASE_URL}${CASE_STUDIES_PATH}`}>
                      Case Studies
                    </StyledAnchor>
                  </Link>

                  <Link>
                    <StyledAnchor href={`${BASE_URL}${WEBINARS_PATH}`}>Webinars</StyledAnchor>
                  </Link>

                  <Link>
                    <StyledAnchor href={`${BASE_URL}${EBOOKS_PATH}`}>eBooks</StyledAnchor>
                  </Link>
                </Grid>
              </Grid>
            </ForProvidersSection>
          ),
        },
      ]}
      theme={expansionPanelTheme}
    />
  );
};

export default Mobile;
